import { type FragmentOf, graphql, readFragment, type Scalar } from "@/graphql"

const graphQLFragments = {
    agreement: graphql(`
        fragment isAgreementCancelled_Agreement on AgreementType {
            status
        }
    `),
}

type IsAgreementTerminatedFromStatusProps = {
    agreement: FragmentOf<typeof graphQLFragments.agreement>
}

const AGREEMENT_CANCELLED_STATUS = ["WITHDRAWN", "CLOSED"] as const satisfies Array<
    Scalar<"ActivationProcessStatus">
>

export function isAgreementCancelled(props: IsAgreementTerminatedFromStatusProps) {
    const agreement = readFragment(graphQLFragments.agreement, props.agreement)

    if (!agreement.status) {
        return false
    }

    return AGREEMENT_CANCELLED_STATUS.includes(agreement.status)
}

isAgreementCancelled.fragments = graphQLFragments
